mainApp.component('discoveryFilter', {
    templateUrl: '/public/components/discovery/discovery-filter.component.html',
    bindings: {
        filters: '<',
        fields: '<',
        fieldsSpec: '<',
        onAddFilter: '&',
        onRemoveFilter: '&',
        fieldSuggestionsFetcher: '&'
    },
    controller: function($scope, DiscoveryQueryService) {
        const ctrl = this;

        ctrl.$onInit = function() {

        };

        ctrl.$onChanges = function(changes) {
            if (changes['fieldsSpec'] && changes['fieldsSpec'].currentValue)
                ctrl.fieldsArr = ctrl.getFieldsArray(changes['fieldsSpec'].currentValue);

            if (ctrl.selectedField && changes['fields'] && changes['fields'].currentValue)
                ctrl.suggestionsArr = ctrl.getSuggestionsArray(ctrl.selectedField);
        };

        ctrl.getFieldsArray = function(obj) {
            const result = [];
            _.forOwn(obj, function(value, key) {
                if (key === 'event_data')
                    return;

                result.push({
                    internal: key,
                    name: value.presentation
                });
            });
            return result;
        };

        ctrl.getOperatorLabel = function(item) {
            return item.descriptor;
        };

        ctrl.removeFilter = function(item) {
            ctrl.onRemoveFilter({deleted: item});
        };

        ctrl.setSelectedField = function(field, $event) {
            ctrl.selectedField = field;
            ctrl.fieldSuggestionsFetcher({field: field.internal});
            ctrl.operatorsArr = DiscoveryQueryService.getOperatorsForFieldType(ctrl.fieldsSpec[field.internal].type);
            ctrl.suggestionsArr = ctrl.getSuggestionsArray(field);

            ctrl.selectedOperator = null;
            $scope.$broadcast('clear-combo', 'filter-operator-select');

            ctrl.filterValue = null;
            $scope.$broadcast('clear-combo', 'filter-value-select');

            ctrl.filterValues = [];
            $scope.$broadcast('clear-combo', 'filter-values-select');

            $event.stopPropagation();
        };

        ctrl.getSuggestionsArray = function(field) {
            const result = [];
            _.forOwn(ctrl.fields.fieldToSuggestions[field.internal], function(value, key) {
                if (key === 'Missing' || key === 'cardinality')
                    return;

                result.push({
                    name: key,
                    usages: value
                });
            });
            return result;
        };

        ctrl.setSelectedOperator = function(operator, $event) {
            $event.stopPropagation();

            ctrl.selectedOperator = operator;

            ctrl.filterValue = null;
            $scope.$broadcast('clear-combo', 'filter-value-select');

            ctrl.filterValues = [];
            $scope.$broadcast('clear-combo', 'filter-values-select');
        };

        ctrl.setSelectedValue = function(value, $event) {
            $event.stopPropagation();

            ctrl.filterValue = value;
        };

        ctrl.addToSelectedValues = function(value, $event) {
            $event.stopPropagation();

            ctrl.filterValues.push(value);
            ctrl.filterValues = ctrl.filterValues.filter(() => true);
        };

        ctrl.removeFromSelectedValues = function(value, $event) {
            $event.stopPropagation();

            ctrl.filterValues = ctrl.filterValues.filter((item) => item != value);
        };

        ctrl.isEverythingPopulated = function() {
            return ctrl.selectedField && ctrl.selectedOperator &&
                (ctrl.selectedOperator.type === 'boolean' ||
                    (ctrl.selectedOperator.type === 'value' && ctrl.filterValue) ||
                    (ctrl.selectedOperator.type === 'list' && ctrl.filterValues.length > 0) ||
                    (ctrl.selectedOperator.type === 'range' && ctrl.filterValueFrom && ctrl.filterValueTo));
        };

        ctrl.openAdvancedFilter = function () {
            ctrl.selectedField = null;
            $scope.$broadcast('clear-combo', 'filter-field-select');

            ctrl.selectedOperator = null;
            $scope.$broadcast('clear-combo', 'filter-operator-select');

            ctrl.filterValue = null;
            $scope.$broadcast('clear-combo', 'filter-value-select');

            ctrl.filterValues = [];
            $scope.$broadcast('clear-combo', 'filter-values-select');

            $scope.$root.openPopup('addFilterDialog');
        };

        ctrl.closeAdvancedFilter = function () {
            $scope.$root.closePopup('addFilterDialog');
        };

        ctrl.addAdvancedFilter = function () {
            $scope.$root.closePopup('addFilterDialog');

            ctrl.onAddFilter({
                field: ctrl.selectedField.internal,
                operator: ctrl.selectedOperator.id,
                value: ctrl.getFilterValue()
            });
        };

        ctrl.getFilterValue = function() {
            if (ctrl.selectedOperator.type === 'value') {
                return ctrl.filterValue.name;
            }

            if (ctrl.selectedOperator.type === 'list') {
                return ctrl.filterValues.map(item => item.name);
            }

            if (ctrl.selectedOperator.type === 'range') {
                return {
                    from: ctrl.filterValueFrom,
                    to: ctrl.filterValueTo
                }
            }

            return null;
        }
    },
});